import React, { useState } from "react";
import {
  Typography,
  Box,
  Toolbar,
  Drawer,
  List,
  ListItem,
} from "@mui/material";
import "./AdminDashboard.css";
import ResponsiveLayout from "../components/ResponsiveLayout";
import Analytics from "./Analytics";
import VideoReview from "./VideoReview";
import UserInfo from "./UserInfo";
import PostReview from "./PostReview";
import Messages from "./Messages";

export default function AdminDashboard() {
  const [selectedSection, setSelectedSection] = useState("analytics");
  return (
    <ResponsiveLayout>
      <Typography
        variant="h3"
        fontWeight="bold"
        color="black"
        textAlign="center"
        gutterBottom
      >
        ADMIN DASHBOARD
      </Typography>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          margin: "0 auto",
          boxShadow: 1,
          backgroundColor: "#fff",
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        <Drawer
          variant="permanent"
          sx={{
            width: 240,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: {
              width: 240,
              boxSizing: "border-box",
              position: "relative",
              padding: "1rem", // drawer internal padding
              fontFamily: "YourFontName", // ensure this matches your theme
            },
          }}
        >
          <Toolbar />
          <List sx={{ mt: 2 }}>
            {[
              { label: "Site Analytics", key: "analytics" },
              { label: "User Information", key: "userInfo" },
              { label: "Messages", key: "messages" },
              { label: "Post Approval Requests", key: "postRequest" },
              { label: "Video Approval Requests", key: "videoRequest" },
            ].map((item) => (
              <ListItem
                button
                key={item.key}
                onClick={() => setSelectedSection(item.key)}
                sx={{
                  borderRadius: 1,
                  mb: 1,
                  "&:hover": {
                    backgroundColor: "#e3f2fd",
                    color: "#1976d2",
                    cursor: "pointer",
                  },
                  fontFamily: "Roboto, sans-serif",
                  fontWeight: "500",
                }}
              >
                {item.label}
              </ListItem>
            ))}
          </List>
        </Drawer>

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            minHeight: "600px",
            width: "100%",
          }}
        >
          <Toolbar />

          {selectedSection === "analytics" && <Analytics />}
          {selectedSection === "userInfo" && <UserInfo />}
          {selectedSection === "messages" && <Messages />}
          {selectedSection === "postRequest" && <PostReview />}
          {selectedSection === "videoRequest" && <VideoReview />}
        </Box>
      </Box>
    </ResponsiveLayout>
  );
}
